
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input } from '@angular/core';

@Component({ 
    selector: 'application-card',
    templateUrl: './application-card.component.html',
    styleUrls: ['./application-card.component.css']
})
export class ApplicationCardComponent extends SiriusBaseComponent<any> {       
    @Input('Link') link: string = "";
    @Input('ImgUrl') imgUrl: string = "";
    @Input('Text') text: string = "";
    @Input('TitleText') titleText: string = "";
    @Input('popuptype') popOver: string = "";
    showPopOver: boolean = false;
    OnInit() {
      
    }
    goMenu() {
        if (this.link != null && this.link != "") {
            this.startTransaction(this.link);
        }
        else if (this.popOver == "sales"){
            this.toggleSalesPopOver(); 
        }           
    }
    toggleSalesPopOver() {
        this.showPopOver = !this.showPopOver;
    }
}
